import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
@Component({
  selector: "app-notification-modal",
  templateUrl: "./notification-modal.component.html",
  styleUrls: ["./notification-modal.component.scss"],
})
export class NotificationModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<NotificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any = null,
    public router: Router,
  ) {}

  ngOnInit() {
    console.log("DATA MODAL");
    console.log(this.modalData);
  }

  closeModal() {
    this.dialogRef.close();
  }

  goToResume() {
    this.closeModal();

    if (this.modalData?.consultationId && this.modalData?.patientId) {
      this.router.navigate(["/consults"], {
        queryParams: {
          id: this.modalData.consultationId,
          patient: this.modalData.patientId,
        },
      });
    }
  }
}
